import { graphql } from "../../gql/index.ts";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { GetUserFrozenWeeksQuery } from "./FreezeWeek/useUserFrozenWeeks.ts";
import { GetUserFreezableWeeksQuery } from "./FreezeWeek/useUserFreezableWeeks.ts";
import { GetUserRemainingLessonsQuery } from "./useUserRemainingLessons.ts";

const DetachLastMergedPlanMutation = graphql(`
  mutation detachLastMergedPlan($planId: String!) {
    detachLastMergedPlan(planId: $planId) {
      ...ClassRoomPlanFragment
    }
  }
`);

export function useDetachLastMergedPlan() {
  const [detachLastMergedPlanMutation, { loading }] = useMutation(
    DetachLastMergedPlanMutation,
    {
      refetchQueries: [
        GetUserFrozenWeeksQuery,
        GetUserFreezableWeeksQuery,
        GetUserRemainingLessonsQuery,
      ],
    },
  );

  const detachLastMergedPlan = useCallback(
    async (planId: string) => {
      await detachLastMergedPlanMutation({
        variables: {
          planId,
        },
      });
    },
    [detachLastMergedPlanMutation],
  );

  return { detachLastMergedPlan, loading };
}
